import styled from 'styled-components';
import { StepStatus } from 'Interfaces/StepStatus';

export const Step = styled.div<{ status: StepStatus }>`
    display: block;
    overflow-y: hidden;
    transition: all 0.3s ease-out;

    ${props =>
        props.status === StepStatus.PENDING &&
        `
        height: 0;
        transform: translateX(100%);
    `}

    ${props =>
        props.status === StepStatus.ACTIVE &&
        `
        height: auto;
        transform: none;
        position: relative;
        left: 0;
        overflow-y: visible;
    `}

    ${props =>
        props.status === StepStatus.COMPLETE &&
        `
        height: auto;
        transform: none;
        position: absolute;
        left: -100%;
        display: none;
    `}
`;
